module.exports = __webpack_public_path__ + "img/token.6b5fccdd.png";